import anime from 'animejs';

import {ConnectedComponent} from '@lib/ConnectedComponent';
import {appSelectors} from '@lib/store/appState';

export class NewsMore extends ConnectedComponent {
  caption: HTMLDivElement | undefined = undefined;
  button: HTMLAnchorElement | undefined = undefined;
  itemsContainer: HTMLDivElement | undefined = undefined;
  title: HTMLDivElement | undefined = undefined;
  page = 1;
  totalPage = 1;
  url = '';

  constructor() {
    super();
    this.onPress = this.onPress.bind(this);
  }

  didMount() {
    this.observe(appSelectors.selectNewsUrl, async (url) => {
      this.page = 1;
      this.url = url;
      if (this.url) {
        const res = await this.fetch(this.url);
        if (this.itemsContainer) {
          this.itemsContainer.innerHTML = '';
        }
        this.attach(res);
      }
    });

    this.title = document.querySelector('.p-news_title p') as HTMLDivElement;
    this.caption = this.element?.querySelector(
      '.p-news_viewmore_caption p',
    ) as HTMLParagraphElement;
    this.totalPage = Number(this.element?.dataset['totalPage']);
    // this.count = Number(this.element?.dataset['count']);
    this.button = this.element?.querySelector(
      '.p-news_viewmore_button',
    ) as HTMLAnchorElement;
    this.itemsContainer = document.querySelector(
      '.p-news_items',
    ) as HTMLDivElement;
    // this.on('click', this.onPress);
    this.button?.addEventListener('click', this.onPress);
  }

  didUnmount() {
    this.button?.removeEventListener('click', this.onPress);
  }

  async fetch(url: string) {
    const response = await fetch(url, {
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    const htmlText = await response.text(); // JSON のレスポンスをネイティブの JavaScript オブジェクトに解釈
    // Convert the HTML string into a document object
    const parser = new DOMParser();
    return parser.parseFromString(htmlText, 'text/html');
  }

  attach(res: Document) {
    const titleElement = res.querySelector(
      '.p-news_title p',
    ) as HTMLParagraphElement;

    if (this.title) {
      this.title.textContent = titleElement.textContent;
    }

    const viewmore = res.querySelector('.p-news_viewmore') as HTMLDivElement;
    const count = Number(viewmore?.dataset['count']);

    const children = [
      ...res.querySelectorAll('.p-news_item'),
    ] as HTMLDivElement[];

    if (this.itemsContainer) {
      children.map((child) => {
        child.classList.add('viewed');
        this.itemsContainer && this.itemsContainer.appendChild(child);
        anime({
          duration: 400,
          easing: 'easeInOutCubic',
          opacity: [0, 1],
          targets: child,
        });
      });

      const len = this.itemsContainer.children.length;
      this.caption &&
        (this.caption.textContent = `${count}件中${len}件を表示中`);

      this.button &&
        (this.button.style.display = len < count ? 'inline-block' : 'none');
      if (count === 0) {
        this.caption &&
          (this.caption.innerHTML = '<span>該当する記事がありません</span>');
      }
    }
  }

  async getPage(url: string) {
    const res = await this.fetch(url);
    this.attach(res);
  }

  async onPress(e: MouseEvent) {
    e.preventDefault();

    const baseUrl = this.url || location.href;
    const url = new URL(baseUrl);
    const params = url.searchParams;
    this.page++;
    params.append('paged', this.page.toString());
    await this.getPage(`${url.origin}${url.pathname}?${params.toString()}`);
  }
}
